type OnMessage = (event: MessageEvent) => void;
type Broadcast = {
  broadcastChannel: BroadcastChannel;
  refCount: number;
  name: string;
  subscribers: OnMessage[];
};
const broadcasts: { [key: string]: Broadcast } = {};

export const subscribeForBroadcastChannel = (name: string, onMessage: OnMessage) => {
  let broadcast = broadcasts[name];
  if (!broadcast) {
    const broadcastChannel = new BroadcastChannel(name);
    broadcast = {
      broadcastChannel,
      refCount: 0,
      name,
      subscribers: [],
    };
    broadcastChannel.onmessageerror = (event) => {
      assert(false, event);
    };
    broadcastChannel.onmessage = (event) => {
      broadcasts[name].subscribers.forEach((subscriber: OnMessage) => subscriber(event));
    };
  }
  broadcast.refCount += 1;
  broadcast.subscribers.push(onMessage);
  broadcasts[name] = broadcast;
};

export const unsubscribeFromBroadcastChannel = (name: string, onMessage: OnMessage) => {
  const broadcast = broadcasts[name];
  if (assert(broadcast, 'broadcast channel not found', { name })) {
    const subscriber = broadcast.subscribers.find((subscriber) => subscriber === onMessage);
    if (assert(subscriber, 'broadcast channel subscriber not found', { name })) {
      broadcast.subscribers = broadcast.subscribers.filter((subscriber: OnMessage) => subscriber !== onMessage);
      broadcast.refCount -= 1;
    }
    if (broadcast.refCount <= 0) {
      broadcast.broadcastChannel.close();
      delete broadcasts[name];
    }
  }
};

export const postMessageToBroadcastChannel = (name: string, message: any) => {
  const broadcast = broadcasts[name];
  try {
    if (broadcast) {
      broadcast.broadcastChannel.postMessage(message);
    } else {
      const broadcastChannel = new BroadcastChannel(name);
      broadcastChannel.postMessage(message);
      broadcastChannel.close();
    }
  } catch (e) {
    assert(false, e, { name, message });
  }
};
